
import { Component, Emit, Vue } from 'nuxt-property-decorator'
import IconInfo from '~/components/icons/IconInfo.vue'
import AppTransition from '~/components/AppTransition'

@Component({
  components: {
    AppTransition,
    IconInfo,
  },
})
export default class AppAlert extends Vue {
  @Emit('close')
  onClose () {
    return true
  }
}
